import { useTranslation } from "react-i18next";

export default function PromoCode({ promocode, setShowCopyMessage }) {
  const { t } = useTranslation();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1; // Adding 1 because months are zero-indexed
    const year = date.getFullYear();

    // Padding single-digit day and month with leading zero if necessary
    const formattedDay = day < 10 ? `0${day}` : day;
    const formattedMonth = month < 10 ? `0${month}` : month;

    return `${formattedDay}/${formattedMonth}/${year}`;
  };

  const copyPromoCode = () => {
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(promocode.label)
        .then(() => setShowCopyMessage(true))
        .catch((error) => {
          console.error("Error copying to clipboard:", error);
        });
    } else {
      console.error("Clipboard API not available");
    }
  };
  return (
    <>
      <div className="promo-code">
        <div className="input-fields">
          <div className="input">
            <label htmlFor="">{t("promo-code")}</label>
            <input type="text" value={promocode.label} disabled />
            <div className="valid">
              <p>
                {t("discount")}:{" "}
                <span>
                  {promocode?.percent !== null
                    ? `${promocode.percent}%`
                    : promocode?.amount !== null && `${promocode.amount}€`}
                </span>
              </p>
              <p>
                {t("expiry-date")}:{" "}
                <span>{formatDate(promocode?.expireAt)}</span>
              </p>
            </div>
          </div>
        </div>
        <div className="buttons">
          <button onClick={copyPromoCode}>{t("copy")}</button>
        </div>
      </div>
    </>
  );
}
